// Mirror of rlink-backend/services/commissionService.js for the rank header.
// When the Connect Partner lookup returns a member rank, we want the dashboard
// and payout center headers to reflect it live rather than wait for the daily
// sync job to update `affiliate.rank`.

const RANK_DISPLAY = {
  impact_blockbot: "Impact BlockBot",
  blockbot: "BlockBot",
  droid: "Droid",
  none: "Unranked",
};

const RANK_RATE = {
  impact_blockbot: 0.35,
  blockbot: 0.30,
  droid: 0.10,
  none: 0.20,
};

export function normalizeConnectRank(raw) {
  if (!raw || typeof raw !== "string") return "none";
  const key = raw.trim().toLowerCase().replace(/\s+/g, "_");
  if (key === "impact_blockbot" || key === "impactblockbot") return "impact_blockbot";
  if (key === "blockbot") return "blockbot";
  if (key === "droid") return "droid";
  return "none";
}

/**
 * If the Connect lookup returned a found member with a rank, return the
 * {rank, rankDisplay, commissionRate} derived from that raw rank string.
 * Otherwise return null — callers should fall through to stored values.
 */
export function resolveRankFromConnect(connect) {
  const rawRank = connect?.lookup?.found ? connect?.lookup?.member?.rank : null;
  if (!rawRank) return null;
  const rank = normalizeConnectRank(rawRank);
  return {
    rank,
    rankDisplay: RANK_DISPLAY[rank],
    commissionRate: RANK_RATE[rank],
  };
}
